<template>
    <div v-wechat-title="title" class="padding10" v-if="surgeryId && surgeryId > 0">
         <el-row type="flex" align="middle">
            <el-col :md="14" class="align-left">

            </el-col>
            <el-col :md="10" class="align-right">
                <el-checkbox v-if="isHavePermissions(`add`)" v-model="continueAdd">连续</el-checkbox>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`add`)" @click="addRecord">新增记录</el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`print`)" @click="printDoc">打印</el-button>
            </el-col>
        </el-row>
        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: this.screenHeight - 165 + 'px' }">
            <ListViewNesting
                style="margin-top: 10px;"
                :span-method="(event)=>objectSpanMethod(event, datalist, fields)"
                :selection="false"
                :showSequence="false"
                :stripe="false"
                ref="record-list"
                :datalist="datalist"
                :tableHeight="this.screenHeight - 172"
                @extrabutton-click="ExtraButtonClick"
                :columns="columnList"
                :buttons="[]"
                :reserveSelection="false"
                @rowDbclick="rowDbclick"
                @rowContextMenu="rowContextMenu"
                @rowClick="rowClick"
            >
            </ListViewNesting>
        </el-scrollbar>
        <!-- 右键菜单 -->
        <div v-if="msgDialogVisible" class="menu_box" :style="{ left: menuLeft + 'px', top: menuTop + 'px' }">
            <div class="menu">
                <div class="menu_item item_text" @click="deleteRecord">删除</div>
            </div>
        </div>
        <AddRecord :visible.sync="record.dialogFormVisible" :title="record.title" :continueAdd="continueAdd" :data="record.data" @save-success="saveAsSuccess"></AddRecord>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import AddRecord from './AddRecord.vue'
export default {
    name: `NursingRecord`,
    props: {},
    components: { AddRecord },
    data() {
        return {
            title: `护理记录`,
            record: {
                dialogFormVisible: false,
                data: {}
            },
            msgDialogVisible: false,
            menuLeft: 0,
            menuTop: 0,
            activeRow: {},
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            continueAdd: false,
            surgeryInfo: {},
            rowSpanMap: {},
            configColumns: [],
            user_config_columns: [],
            user_config_columns2: [],
            tableName: `api_Nursing/Record`,
            datalist: [],
            fields: [`biz_nursing_record_id`,
                `record_time`,
                `vital_sign_t`,
                `vital_sign_p`,
                `vital_sign_r`,
                `vital_sign_bp`,
                `pain_score`,
                `enum_consciousness_state`,
                `consciousness_state`,
                `left_pupil_size`,
                `enum_light_reflection_left`,
                `right_pupil_size`,
                `enum_light_reflection_right`,
                `oxygen_uptake`,
                `pulse_oxygen_saturation`,
                `skin_condition`,
                `enum_nursing_measures`,
                `notes`,
                `nurse_name`],
            // 右键菜单
            menus: [
                { name: `编辑`, operType: 1 },
                { name: `删除`, operType: 2 }
            ]
        }
    },
    computed: {
        ...mapGetters([`permissions`, `ward_auth`, `screenHeight`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `currentUser`, `currentSurgery`, `sys_enums`, `enum_region_type`, `active_ward`, `sysuser/workers_by_duty`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        columnList() {
            let list = [
                { type: `string`,
                    prop: `biz_nursing_record_id`,
                    label: `编号`,
                    isListable: false
                },
                { type: `string`,
                    prop: `biz_nursing_record_item_id`,
                    label: `编号`,
                    isKey: true,
                    isListable: false
                },
                {
                    type: `datetime`,
                    prop: `record_time`,
                    nestedRows: 1,
                    label: `日期时间`,
                    width: `130`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `vital_sign_t`,
                    nestedRows: 3,
                    groupName: `生命体征`,
                    nextGroupName: `T`,
                    label: `℃`,
                    width: `40`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `vital_sign_p`,
                    nestedRows: 3,
                    groupName: `生命体征`,
                    nextGroupName: `P`,
                    label: `次/分`,
                    width: `45`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `vital_sign_r`,
                    nestedRows: 3,
                    groupName: `生命体征`,
                    nextGroupName: `R`,
                    label: `次/分`,
                    width: `45`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `vital_sign_bp`,
                    nestedRows: 3,
                    groupName: `生命体征`,
                    nextGroupName: `BP`,
                    label: `mmHg`,
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `pain_score`,
                    nestedRows: 1,
                    label: `疼痛评分`,
                    width: `30`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_consciousness_state`,
                    nestedRows: 1,
                    label: `意识状态`,
                    width: `45`,
                    isListable: true,
                    options: this.sys_enums.Enum_ConsciousnessState || []
                },
                {
                    type: `string`,
                    prop: `left_pupil_size`,
                    nestedRows: 2,
                    groupName: `瞳孔(mm)`,
                    label: `左`,
                    width: `35`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_light_reflection_left`,
                    nestedRows: 2,
                    groupName: `瞳孔(mm)`,
                    label: `光反射`,
                    width: `50`,
                    isListable: true,
                    options: this.sys_enums.Enum_LightReflection || []
                },
                {
                    type: `string`,
                    prop: `right_pupil_size`,
                    nestedRows: 2,
                    groupName: `瞳孔(mm)`,
                    label: `右`,
                    width: `35`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_light_reflection_right`,
                    nestedRows: 2,
                    groupName: `瞳孔(mm)`,
                    label: `光反射`,
                    width: `50`,
                    isListable: true,
                    options: this.sys_enums.Enum_LightReflection || []
                },
                {
                    type: `string`,
                    prop: `oxygen_uptake`,
                    nestedRows: 2,
                    groupName: `吸氧`,
                    label: `L/min`,
                    width: `50`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `pulse_oxygen_saturation`,
                    nestedRows: 2,
                    groupName: `SPO2`,
                    label: `%`,
                    width: `50`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `tube_name`,
                    nestedRows: 2,
                    groupName: `管路`,
                    label: `名称`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `tube_patency`,
                    nestedRows: 2,
                    groupName: `管路`,
                    label: `通畅`,
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `in_drug_name`,
                    nestedRows: 3,
                    groupName: `入量(ml)`,
                    nextGroupName: `临床用药`,
                    label: `项目`,
                    width: `150`,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `in_drug_dose`,
                    nestedRows: 3,
                    groupName: `入量(ml)`,
                    nextGroupName: `临床用药`,
                    label: `量`,
                    width: `50`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `add_way`,
                    nestedRows: 3,
                    groupName: `入量(ml)`,
                    nextGroupName: `临床用药`,
                    label: `途径`,
                    width: `70`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `speed`,
                    nestedRows: 3,
                    groupName: `入量(ml)`,
                    nextGroupName: `临床用药`,
                    label: `流速`,
                    width: `70`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `in_stomach_item`,
                    nestedRows: 3,
                    groupName: `入量(ml)`,
                    nextGroupName: `胃肠`,
                    label: `项目`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `in_stomach_dose`,
                    nestedRows: 3,
                    groupName: `入量(ml)`,
                    nextGroupName: `胃肠`,
                    label: `量`,
                    width: `50`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `out_item_name`,
                    nestedRows: 2,
                    groupName: `出量(ml)`,
                    label: `项目`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `out_color_characteristics`,
                    nestedRows: 2,
                    groupName: `出量(ml)`,
                    label: `颜色性状`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `out_dose`,
                    nestedRows: 2,
                    groupName: `出量(ml)`,
                    label: `量`,
                    width: `50`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `skin_condition`,
                    nestedRows: 1,
                    label: `受压皮肤情况`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_nursing_measures`,
                    nestedRows: 1,
                    label: `基础护理措施`,
                    width: `120`,
                    isListable: true,
                    options: this.sys_enums.Enum_NursingMeasures || []
                },
                {
                    type: `string`,
                    prop: `notes`,
                    nestedRows: 1,
                    label: `病情观察及措施`,
                    width: `250`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `nurse_name`,
                    nestedRows: 1,
                    label: `护士`,
                    width: `80`,
                    isListable: true
                }
            ]
            return list
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            allcolumn.map(d => {
                let f = that.user_config_columns2.find(s => s.col_name == d.prop)
                if (f && f.col_width > 0) {
                    d.width = f.col_width
                }
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadNursingRecordInfo()
    },
    mounted() {
    },
    methods: {
        addRecord() {
            if (!this.surgeryId) return
            this.record.dialogFormVisible = true
            this.record.title = `新增记录`
            this.record.data = {
                biz_surgery_info_id: this.surgeryId
            }
        },
        saveAsSuccess() {
            this.loadNursingRecordInfo()
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }, data, fields) {
            const checkMergeFields = (row, nextRow, property) => {
                let ret = true
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i]
                    if (nextRow[field] != row[field]) {
                        ret = false
                        break
                    }
                    if (field == property) {
                        break
                    }
                }
                return ret
            }
            if (fields.length == 0) {
                return
            }
            const cellValue = row[column.property] || ``
            if (cellValue != undefined && cellValue != null && fields.includes(column.property)) {
                const prevRow = data[rowIndex - 1]
                let nextRow = data[rowIndex + 1]
                if (prevRow && checkMergeFields(row, prevRow, column.property)) {
                    return { rowspan: 0, colspan: 0 }
                } else {
                    let countRowspan = 1
                    while (nextRow && checkMergeFields(row, nextRow, column.property)) {
                        nextRow = data[++countRowspan + rowIndex]
                    }

                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 }
                    }
                }
            }
        },
        isHavePermissions(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `nursing_record:${permiskey}`) != -1
        },
        loadNursingRecordInfo() {
            let that = this
            that.datalist = []
            if (!that.surgeryId) {
                return
            }
            this.myaxios
                .get(`/api/Nursing/NursingRecord/GetBySurgeryId?surgeryId=${that.surgeryId}`)
                .then(data => {
                    that.datalist = data
                    console.log(`datalist`, that.datalist)
                })
                .catch(e => { console.log(e) })
        },
        printDoc() {
            let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[`NR001`],
                            id1: `${this.surgeryId}`,
                            objId: ``,
                            from: this.$moment().format(`YYYYMMDDHHmm`),
                            to: this.$moment().format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        ExtraButtonClick({ emit, row, event, column }) {
            this.activeRow = {}
            if (emit == `rowDbclick`) {
                this.rowDbclick(row)
            } else if (emit == `rowClick`) {
                this.rowClick(row)
            } else if (emit == `rowContextMenu`) {
                this.activeRow = row
                this.rowContextMenu(event)
            }
        },
        rowClick(row) {
            this.msgDialogVisible = false
        },
        rowDbclick(row) {
            if (this.isHavePermissions(`edit`)) {
                if (!this.surgeryId) return
                this.record.dialogFormVisible = true
                this.record.data = row
                this.record.title = `修改记录`
            }
        },
        deleteRecord() {
            let that = this
            that.msgDialogVisible = false
            if (that.activeRow && that.activeRow.biz_nursing_record_id && that.activeRow.record_time) {
                let deleteTime = this.$moment(that.activeRow.record_time).format(`YYYY/MM/DD HH:mm`)
                that.$confirm(`是否确定删除【${deleteTime}】的护理记录?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`
                }).then(() => {
                    let req = that.myaxios.delete(`/api/Nursing/NursingRecord/DeleteByRecordId?recordId=${that.activeRow.biz_nursing_record_id}`)
                    req.then(data => {
                        that.$message.success(`删除成功！`)
                        that.loadNursingRecordInfo()
                    }).catch(e => {
                        console.log(e)
                    })
                })
            }
        },
        rowContextMenu(event) {
            if (this.isHavePermissions(`delete`)) {
                // 阻止元素发生默认的行为
                event.preventDefault()
                let that = this
                this.msgDialogVisible = true
                that.menuLeft = event.clientX || 0
                that.menuTop = event.clientY || 0
            }
        },
        LoadUserColumns() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=${that.tableName}`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })

                this.configColumns = lcs.filter(d => {
                    return d.label != `unique` && d.isListable !== false
                }).map(c => {
                    return { value: c.prop, label: c.label }
                })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                this.user_config_columns2 = data && _.filter(data, { enabled: true }).map(d => {
                    return {
                        col_name: d.col_name,
                        col_width: d.col_width
                    }
                }) || []
                this.$nextTick(() => {
                    let chks = this.$refs.configColumnRef.$el.querySelectorAll(`.el-checkbox`)
                    for (let i = chks.length - 1; i >= 0; i--) {
                        let chk = chks[i]
                        if (chk.innerText == `操作`) {
                            chk.style.display = `none`
                            break
                        }
                    }
                })
            })
        },
        SaveUserColumns() {
            let that = this
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: that.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        changeColWidthBody(nw, ow, col, evt) {
            if (nw < 20) {
                nw = 20
            } else if (nw > 500) {
                nw = 500
            }
            let r = {
                col_name: col.property,
                col_width: parseInt(nw),
                table_name: this.tableName
            }
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnWidth`, r)
            req.then(data => {
                this.$message.success(`列宽调整成功`)
                // if (this.reload) {
                //     this.reload()
                // }
            }).catch(e => {})
        },
        changeColWidth(nw, ow, col, evt) {
            let that = this
            // 列宽值改变则post列宽
            if (this.user_config_columns2.length == 0) {
                let uc = this.configColumns.map((c, index) => {
                    return {
                        col_name: c.value,
                        display_order: index,
                        enabled: _.includes(this.user_config_columns, c.value),
                        table_name: this.tableName
                    }
                })
                let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
                req.then(data => {
                    that.LoadUserColumns().then(d => {
                        that.changeColWidthBody(nw, ow, col, evt)
                    })
                }).catch(e => { })
            } else {
                that.changeColWidthBody(nw, ow, col, evt)
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadNursingRecordInfo()
        }
    }
}
</script>
<style scoped lang="less">
/deep/ .el-table {
    font-size: 14px !important;
    color: black !important;
}
/deep/.el-table th .cell {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
/deep/.el-table th {
    padding: 1px 1px !important;
}

/deep/.el-table td {
    padding: 1px 1px !important;
}
/deep/ .theme-dark .el-table th .cell,
/deep/ .theme-his-blue .el-table th .cell{
    line-height: 20px !important;
}
/deep/ .el-table td .cell {
    padding-left: 1px !important;
    padding-right: 1px !important;
}
/deep/div.cell.el-tooltip{
    white-space: normal !important;
    min-width: 10px !important;
}
/deep/ th{
    border: 1px solid LightGray !important;
}
/deep/ td{
    border: 1px solid LightGray !important;
}
.menu_box {
    position: fixed;
    z-index: 1004;
    background-color: #fff;
    .menu {
        width: 100px;
        text-align: left;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .menu_item {
            height: 24px;
            line-height: 22px;
        }
        .item_text {
            border: 1px solid red;
            color: red;
            cursor: pointer;
            padding: 4px 20px;
            // border-radius: 3px;
            transition: all 0.2s ease-in;
        }
        .item_text:hover {
            color: white;
            background-color: red;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/NursingRecord/Index.vue